import {stateData, reduxState} from '../../values';

const initialState = {
    fares:          [],
    status:         stateData.state1,
    faresEdit:      [],
    records:        1
};

const reducer = (state=initialState, action) =>{
    if(action.type === reduxState.get_fares){
        return {
            ...state,
            fares:      action.payload,
            status:     action.status,
            records:    action.records
        }
    }
    if(action.type === reduxState.update_fares){
        return {
            ...state,
            faresEdit: action.payload
        }
    }
    return state
}
export default reducer
